import { useState } from 'react'
import { cn } from '@/lib/utils'

interface Tab {
  id: string
  label: string
  icon?: React.ReactNode
}

interface TabsProps {
  tabs: Tab[]
  defaultTab?: string
  children: React.ReactNode[]
  className?: string
}

export function Tabs({ tabs, defaultTab, children, className }: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id)

  return (
    <div className={cn('w-full', className)}>
      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <div className="-mx-4 overflow-x-auto px-4 sm:mx-0 sm:px-0">
          <nav className="-mb-px flex min-w-max gap-6 sm:gap-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={cn(
                  'flex min-h-[44px] items-center whitespace-nowrap border-b-2 px-1 py-2 text-sm font-medium transition-colors',
                  activeTab === tab.id
                    ? 'border-orange-500 text-orange-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                )}
              >
                {tab.icon ? <span className="mr-2">{tab.icon}</span> : null}
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {children.map((child, index) => {
          const tab = tabs[index]
          return (
            <div
              key={tab.id}
              className={cn(
                'space-y-6',
                activeTab === tab.id ? 'block' : 'hidden'
              )}
            >
              {child}
            </div>
          )
        })}
      </div>
    </div>
  )
}
